import * as ko from "knockout";
import {Abstract} from "./Abstract";
import {getAnyValue} from "../../../util/misc";
import headingHtml from './heading.html?raw';

export let template = headingHtml;

export class viewModel extends Abstract {

    protected override getTitle(): string {
        return getAnyValue(this.get().description ?? this.get().label) ?? '';
    }

    protected validate = ko.pureComputed((): boolean => {
        return this.get().validator?.() ?? true;
    })
}
